<template>
  <div id="left-menu" :class="{ opened: menu_expanded }">
    <div class="mheader" @click="redirect('home')"></div>

    <div class="mbody hide-scrollbar">
      <div
        class="item"
        id="club"
        @click="redirect('home')"
        :class="{ active: activePage == 'home' }"
      >
        <p class="name">{{ user.fullname }}</p>
      </div>
      <div
        id="edit"
        class="item"
        @click="redirect('edit')"
        :class="{ active: activePage == 'edit' }"
      >
        <p class="name">{{ $t("volunteers.profile.see") }}</p>
      </div>

      <template v-for="event in user.events">
        <!-- SOLO MOSTRAMOS LOS EVENTOS A LOS CUALES EL USUARIO ESTA CONFIRMADO -->
        <div v-if="event.status == 16" class="item" :key="event.id">
          <p
            class="name"
            :class="{ active: event.id == activeId }"
            @click="redirect('event', event.id)"
          >
            {{ event.name + " " + event.edition.substring(2, 4) }}
          </p>

          <div class="submenu">
            <div
                v-if="false"
              class="subitem"
              @click="redirect('manuals', event.id)"
              :class="{
                active: event.id == activeId && activePage == 'manuals'
              }"
            >
              {{ $t("volunteers.manuals") }}
            </div>
            <div
              class="subitem"
              @click="redirect('necessary_information', event.id)"
              :class="{
                active:
                  event.id == activeId && activePage == 'necessary_information'
              }"
            >
              {{ $t("volunteers.necessary_information") }}
            </div>
            <div
              class="subitem"
              @click="redirect('necessary_documents', event.id)"
              :class="{
                active:
                  event.id == activeId && activePage == 'necessary_documents'
              }"
            >
              {{ $t("volunteers.necessary_documents") }}
            </div>
          </div>
        </div>
      </template>

      <div class="item" id="footer">
        <div @click="logout()" id="logout" class="name">{{ $t("logout") }}</div>
        <Language></Language>
      </div>

      <a href="http://micsports.es/" target="_blank">
        <div class="item" id="legend">
          <span class="description">{{ $t("organitzation") }}</span>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
import { Api } from "@/core/api.js";
const api = new Api();

import i18n from "@/i18n";
import Language from "@/components/ui/Language.vue";

export default {
  name: "LeftMenu",
  components: {
    i18n,
    Language
  },
  props: {
    expanded: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      activePage: "",
      activeId: ""
    };
  },
  methods: {
    onChangeRoute() {
      this.activePage = this.$route.name;
      this.activeId = this.$route.params.event_id;
    },

    redirect(path, id) {
      this.$router.push({ name: path, params: { event_id: id } });
    },

    logout() {
      self.$store.commit("user/setAuthenticate", false);
      self.$store.commit("setOverlayVisible", false);
      self.$store.commit("setUserMenuVisible", false);
      self.$router.replace({ name: "login" });
    }
  },

  computed: {
    user() {
      return this.$store.getters["user/getUser"];
    },
    menu_expanded() {
      return this.expanded ? true : false;
    }
  },

  watch: {
    $route: "onChangeRoute"
  },

  created() {
    this.onChangeRoute();
  }
};
</script>

<style lang="scss" scoped>
$text-color: #eee;
$bg-color: #222;
$bg-color-hover: #2a2a2a;
$bg-alter-color: #333;
$bg-alter-color-hover: #3a3a3a;

#left-menu {
  background-color: #fff;
  // border-right: 1px solid #ddd;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.15);
  -webkit-box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.15);
  height: 100%;
  width: 300px;
  overflow: hidden;
  padding: 0;
  display: inline-block;
  top: $header-height;
  left: 0;
  top: 0;
  position: fixed;
  z-index: 30; // TODO
  transition-duration: 0.1s;

  .mheader {
    height: 140px;
    text-align: center;
    transition-duration: 0.2s;
    cursor: pointer;
    background-color: #111;
    @include background(
      $image: img("logo_new.png"),
      $position: center,
      $size: 200px
    );

    // img {
    //   height: 100px;
    //   margin: 0 auto;
    //   display: inline-block;
    //   vertical-align: middle;
    // }
  }

  .mbody {
    height: calc(100% - 200px);
    overflow: auto;
    padding: 15px;

    #club,
    #uniform {
      .name {
        &:hover {
          text-decoration: underline;
        }
      }
    }

    .category {
      .team {
        margin: 10px 0;
        font-size: 15px;
        padding: 10px;
      }

      .active {
        background-color: #fff4d7;
      }
    }

    .item {
      background: #fff;
      padding: 10px;
      border-left: 5px solid transparent;
      cursor: pointer;

      .name {
        &.active {
          color: #fc8926;
        }
      }

      &#category {
        border-bottom: 1px solid #ddd;

        .name {
          padding: 10px 0;
          text-transform: uppercase;
          font-weight: bold;
          font-family: Roboto-Bold;
          font-family: AvantGarde-Bold;
          @include background(
            $image: img("down.svg"),
            $position: right 0px center,
            $size: 14px
          );

          &.active {
            color: #fc8926;
          }

          &:hover {
            text-decoration: underline;
          }
        }
      }

      &#footer {
        display: none;

        #logout {
          @include background(
            $image: img("logout.svg"),
            $size: 20px,
            $position: left 6px center
          );
          width: calc(100% - 50px);
          padding-left: 33px;
          float: left;
          font-size: 16px;
          cursor: pointer;
        }
        .change_club {
          @include background(
            $image: img("change.svg"),
            $size: 20px,
            $position: 6px 30px
          );
          padding-left: 33px;
          font-size: 16px;
          cursor: pointer;
          font-family: AvantGarde-Bold;
        }
      }

      .name {
        font-family: AvantGarde-Bold;
      }

      &.active {
        border-left: 6px solid #fc8926;
        background-color: #fff4d7;
        border-radius: 2px;
      }

      .submenu {
        padding-left: 25px;

        .subitem {
          padding: 5px;
          padding-left: 10px;
          border-left: 5px solid transparent;

          .number {
            float: right;
            font-family: AvantGarde-Bold;
          }

          &.active {
            border-left: 6px solid #fc8926;
            background-color: #fff4d7;
            border-radius: 2px;
          }

          &:hover {
            text-decoration: underline;
          }

          .name {
          }
        }
      }
    }

    .menu-item {
      @include background(
        $image: img("users.svg"),
        $position: left 6px center,
        $size: 22px
      );
      @include display-flex();
      @include align-items();
      color: $text-color;
      height: 50px;
      width: 100%;
      font-size: 18px;
      padding-left: 36px;
      cursor: pointer;

      &.teams {
        background-image: img("users.svg");
        border-bottom: 2px solid #424242;
      }
    }

    .info {
      @include display-flex();
      @include align-items();
      @include flex-wrap(wrap);
      min-height: 50px;
      height: auto;
      cursor: pointer;

      .club {
        @include background(
          $image: (
            img("club.svg"),
            img("right_light.svg")
          ),
          $position: (
            left 8px center,
            right 12px center
          ),
          $size: (
            26px,
            12px
          )
        );
        width: 100%;
        padding: 12px 24px 6px 42px;

        p {
          @include text-ellipsis();
          margin: 0;
          color: $text-color;
          text-align: left;
          line-height: 0.8;
        }
        .club-name {
          font-size: 22px;
          margin: 20px 0;
        }
        .name {
          font-size: 18px;
          text-transform: uppercase;
        }
        .category {
          font-size: 15px;
          text-transform: uppercase;
        }
      }

      .team {
        @include display-flex();
        @include flex-wrap(wrap);
        @include align-items(center);
        // padding: 6px 6px 9px 6px;
        // padding: 0px 6px 0px 6px;
        padding: 0px;
        width: 100%;
        height: 40px;
        background-color: #333;
        // border-bottom: 1px solid #222;

        .name {
          @include text-ellipsis();
          text-transform: uppercase;
          color: $text-color;
          margin: 0;
          padding: 0;
          padding-left: 12px;
          text-align: left;
          font-size: 20px;
          font-weight: bold;
          width: 100%;
          // height: 100%;
          line-height: 40px;
          display: inline-block;

          &.expandable {
            @include background(
              $image: img("down_caret_eee.svg"),
              $position: left 9px center,
              $size: 7px
            );
            padding-left: 22px;
          }
        }

        .change-team {
          display: none;
        }
      }

      .team.opened {
        height: auto;

        .name.expandable {
          background-image: img("up_caret_light.svg");
        }

        .change-team {
          // border-top: 1px solid #171717;
          // background-color: rgba(255, 255, 255, 0.01);
          background-color: #444;
          display: block;
          width: 40px;
          width: 100%;
          padding-left: 12px;

          .item {
            @include text-ellipsis();
            line-height: 40px;
            color: $text-color;
            padding-left: 6px;
            font-size: 18px;
            transition-duration: 0.1s;

            &:hover {
              // background-color: rgba(255, 255, 255, 0.05);
              cursor: pointer;
              font-weight: bold;
            }
          }
        }
      }

      &:hover {
        background-color: $bg-color-hover;
      }
    }

    .resume {
      background-color: $bg-alter-color;
      padding: 0;

      .item {
        @include background(
          $image: img("right_light.svg"),
          $size: 12px,
          $position: right 6px center
        );
        @include border-radius(3px);
        @include display-inline-flex();
        @include align-items();
        height: 50px;
        width: calc(100% - 20px);
        background-color: #111;
        margin: 10px 10px 0 10px;
        padding: 2px 9px 2px 0px;
        cursor: pointer;
        transition-duration: 0.2s;

        .value,
        .label {
          color: $text-color;
        }
        .value {
          width: 75px;
          height: 100%;
          font-size: 24px;
          font-weight: bold;
          text-align: center;

          .count,
          .total {
            display: inline-block;
            color: $text-color;
            line-height: 45px;
          }
          .count {
            font-size: 30px;
            margin-right: 2px;
          }
          .total {
            font-size: 16px;
            font-weight: bold;
          }
        }
        .label {
          @include text-ellipsis();
          width: calc(100% - 75px);
          font-size: 17px;
        }

        &:hover {
          background-color: $bg-color;
        }
        &:last-of-type {
          margin-bottom: 10px;
        }

        &.alert {
          @include background(
            $image: (
              img("right_light.svg"),
              linear-gradient(115deg, $warning-color 0%, transparent 50%)
            ),
            $size: (
              12px,
              cover
            ),
            $position: (
              right 6px center,
              center
            )
          );
          // @include background ( $image: img('right_light.svg'), $color: $warning-color, $size: 12px, $position: right 6px center );

          .label {
          }
          .value {
            @include background(
              $image: img("empty_estimated.svg"),
              $size: 26px,
              $position: center
            );
          }
        }
      }
    }

    .categoryList {
      // max-height: calc(100% - 50px);
      // overflow: auto;
      background-color: #111;

      .category {
        // margin-top: 12px;
        padding: 6px;

        &:first-of-type {
          // margin-top: 0;
        }

        .title-cat {
          text-transform: uppercase;
          color: #aaa;
          text-align: left;
          font-size: 12px;
          margin: 0;

          span {
            text-transform: inherit;
            text-align: inherit;
            font-size: inherit;
            font-weight: bold;
            color: #ddd;
          }
        }

        .team {
          @include display-flex();
          @include align-items();
          height: 35px;
          border-bottom: 1px solid $bg-alter-color;
          cursor: pointer;
          text-align: left;

          &:last-of-type {
            border: none;
          }

          &:before {
            @include border-radius(8px);
            content: "";
            height: 8px;
            width: 8px;
            background-color: transparent;
            display: inline-block;
            margin-right: 4px;
          }

          .name {
            @include background($size: 20px, $position: right 6px center);
            @include display-flex();
            @include align-items();
            @include text-ellipsis();
            color: $text-color;
            font-size: 16px;
            width: 100%;
            height: 100%;
            padding-right: 30px;
            transition-duration: 0.2s;
          }

          &:hover .name {
            font-weight: bold;
          }
        }
      }
    }
  }

  .mfooter {
    position: absolute;
    bottom: 0;
    background-color: $bg-alter-color;
    width: 100%;
    height: 50px;

    > div {
      @include text-ellipsis();
      height: 100%;
      display: flex;
      align-items: center;
    }

    .logout {
      @include background(
        $image: img("logout.svg"),
        $size: 20px,
        $position: left 6px center
      );
      width: calc(100% - 50px);
      padding-left: 33px;
      float: left;
      font-size: 16px;
      cursor: pointer;
      color: #eee;
    }
  }

  #legend {
    height: 50px;
    width: 100%;
    border-top: 1px solid #eee;
    position: absolute;
    bottom: 0;
    left: 0;
    transition: background-color 0.5s ease;

    @include background(
      $image: img("logo_new_black.png"),
      $position: center,
      $size: 80px
    );

    &:hover {
      background-color: #e8e8e8;
    }

    span {
      display: block;
      margin: 0 auto;
      text-align: center;
      padding: 5px 170px 0 0;
    }
  }

  @include media(">=tablet", "<desktop") {
  }

  @include media(">phone", "<tablet") {
    width: 0;

    &.opened {
      width: calc(100% - 50px);
    }

    .mbody {
      .item {
        &#footer {
          display: block;
        }
      }
    }

    #legend {
      span {
        text-align: inherit;
        padding-left: 15px;
      }
    }
  }
}

@include media("<tablet") {
  #left-menu {
    z-index: 99999;
  }
}

.active {
  // background-color: $main-color !important;

  // border: 2px solid $main-color-t40;

  // &:hover {
  //   background-color: $secondary-color;
  // }
}
.active-dark {
  background-color: $main-color-s30 !important;

  // &:hover {
  //   background-color: $secondary-color;
  // }
}

@media print {
  #left-menu {
    width: 0;
  }
}
</style>
